const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the custom video player component
 * @argument {$sce} $sce the resource defined to manage $sce
 * @argument {Application} Application the service defined to manage Application specific tools and functions
 */


app.directive('customVideoPlayer', ['$sce', 'Application', 'Analyze', function ($sce, Application, Analyze) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        videoLink: '=',
        videoSource: '=',
        videoCreated: '=?',
        mediaId: '=?',
        tracking: '=?',
        onComplete: '&?',
        completionPercent: '=?',
        vttFiles: '=?'
      },
      template: require('../../templates/directives/custom-video-player.html'),
      link: function (scope, element, attrs) {
        var locales = Application.locales;
        var el = element[0];
        var init = 0;
        scope.loading = true;
        scope.settings = {};
        scope.fullElement = {};
        scope.isPlaying = false;
        var duration;
        var seekTime;
        var seekTo;

        var record = function () {
          if (!scope.mediaId) {
            return;
          }
          var duration = scope.fullElement.video.duration;
          var current = scope.fullElement.video.currentTime;
          var percent = current / duration * 100;
          scope.tracking.checkFurthest(percent);
          Analyze.record(
            {resource: 'user-videos'},
            {content: scope.mediaId, position: percent}
          ).$promise.then(function(record){});

          if (scope.completionPercent && scope.onComplete && typeof scope.completionPercent === 'number' && percent > scope.completionPercent) {
            scope.onComplete();
          }
        };

        var changeIsPlaying = function(b){
          scope.isPlaying = b;
          scope.$apply();
        };

        var checkSeek = function() {
          if (!scope.mediaId) {
            return;
          }
          Analyze.userVideos({subresource: scope.mediaId}).$promise
          .then(function(item) {
            if (typeof scope.completionPercent === 'number' && typeof item.furthest_position === 'number' && item.furthest_position > scope.completionPercent) {
              scope.onComplete();
            }
            if (!item || !item.last_position) {
              scope.tracking.setInitialPosition(0);
              return;
            }
            scope.tracking.setInitialPosition(item.last_position);
            if (scope.loading) {
              seekTime = item.last_position;
              return;
            }
            seekTo(item.last_position);
          });
        };

        var initialize = function () {
          var elem = scope.fullElement;
          var settings = scope.settings;

          if (init) {
            scope.loading = true;
            elem.seek.style.width = '0%';
            settings.displayBlock.setDisplay(0, 'currentTime');
            makeLink();
            checkSeek();
            return;
          }
          elem.video = el.querySelector('.js-video');
          elem.playButton = el.querySelector('.js-play');
          elem.playOverlay = el.querySelector('.js-play-overlay');
          elem.timeDisplay = el.querySelector('.js-time');
          elem.seekContainer = el.querySelector('.js-seek');
          elem.seek = elem.seekContainer.querySelector('.js-seek-bar');
          elem.muteButton = el.querySelector('.js-mute');
          elem.volumeContainer = el.querySelector('.js-volume');
          elem.volume = elem.volumeContainer.querySelector('.js-volume-bar');
          elem.fullScreenButton = el.querySelector('.js-fullscreen');
          settings.ratio = (attrs.height / attrs.width) * 100;
          settings.volumeValue = 0.5;
          element[0].style.paddingTop = settings.ratio + '%';

          elem.video.volume = 0.5;
          elem.volume.style.width = '50%';

          elem.seek.style.width = '0%';

          addListeners();

          init++;
          makeLink();
          checkSeek();
        };

        var addListeners = function() {
          var elem = scope.fullElement;
          var settings = scope.settings;

          settings.displayBlock = {
            setDisplay: function (time, type) {
              time = Math.round(time);
              var hrs = ~~(time / 3600);
              var mins = ~~((time % 3600) / 60);
              var secs = time % 60;
              var ret = '';

              if (hrs > 0) {
                ret += '' + hrs + ':' + (mins < 10 ? '0' : '') + mins + ':';
              } else {
                ret += '' + (!mins ? '0' : mins) + ':';
              }

              ret += (secs < 10 ? '0' : '') + secs;

              this[type] = ret;
              elem.timeDisplay.innerText = elem.timeDisplay.textContent = this.currentTime + '/' + this.duration;
            },
            currentTime: '0:00',
            duration: '0:00'
          };

          scope.$on('pausevideo', function(event, data) {
            elem.video.pause();
            record();
          });

          elem.video.addEventListener('loadedmetadata', function () {
            settings.displayBlock.setDisplay(elem.video.duration, 'duration');
          });

          elem.video.addEventListener('play',function () {
            changeIsPlaying(true);
          });

          elem.video.addEventListener('pause',function () {
            changeIsPlaying(false);
          });

          elem.playButton.addEventListener("click", function () {
            elem.video.paused ? elem.video.play() : elem.video.pause();
            if (elem.video.paused) {
              record();
            }
          });

           elem.playOverlay.addEventListener("click", function () {
            elem.video.paused ? elem.video.play() : elem.video.pause();
             if (elem.video.paused) {
               record();
             }
          });

          elem.muteButton.addEventListener("click", function () {
            elem.video.muted = !elem.video.muted ? 1 : 0;
            elem.muteButton.classList.toggle('active');
            setVolumeVisual( elem.video.muted ? 0 : settings.volumeValue );
          });

          elem.fullScreenButton.addEventListener("click", function () {
            if (elem.video.requestFullscreen) {
              elem.video.requestFullscreen();
            } else if (elem.video.mozRequestFullScreen) {
              elem.video.mozRequestFullScreen(); // Firefox
            } else if (elem.video.webkitRequestFullscreen) {
              elem.video.webkitRequestFullscreen(); // Chrome and Safari
            } else if (elem.video.webkitEnterFullscreen) {
              elem.video.webkitEnterFullscreen();
            }
          });

          var getElementOffset = function (element) {
            var de = document.documentElement;
            var box = element.getBoundingClientRect();
            var top = box.top + window.pageYOffset - de.clientTop;
            var left = box.left + window.pageXOffset - de.clientLeft;
            return {
              top: top, left: left
            };
          };

          elem.seekContainer.addEventListener("click", function (e) {
            var offset = e.clientX - getElementOffset(elem.seekContainer).left;
            var time = (offset / elem.seekContainer.getBoundingClientRect().width) * elem.video.duration;
            elem.seek.style.width = (offset / elem.seekContainer.getBoundingClientRect().width) * 100 + '%';
            settings.displayBlock.setDisplay(elem.video.currentTime, 'currentTime');
            elem.video.currentTime = time;
          });

          seekTo = function(percent) {
            elem.seek.style.width =  percent + '%';
            elem.video.currentTime = parseInt(percent) / 100 * elem.video.duration;
            settings.displayBlock.setDisplay(elem.video.currentTime, 'currentTime');
          };

          elem.video.addEventListener("timeupdate", function () {
            var newVal = (elem.video.currentTime / elem.video.duration) * 100;
            settings.displayBlock.setDisplay(elem.video.currentTime, 'currentTime');
            elem.seek.style.width = newVal + '%';
          });

          elem.video.addEventListener("ended", function (e) {
            record();
            changeIsPlaying(false);
          });

          var setVolumeVisual = function(newVolume) {
            elem.volume.style.width = newVolume * 100 + '%';
          };

          elem.volumeContainer.addEventListener("click", function (e) {
            var offset = e.clientX - getElementOffset(elem.volumeContainer).left;
            settings.volumeValue = (offset / elem.volumeContainer.getBoundingClientRect().width);
            setVolumeVisual(settings.volumeValue);
            elem.video.volume = settings.volumeValue;
          });
        };

        var makeLink = function() {
          var elem = scope.fullElement;

          var setLink = function(link, ending, mobile) {
            if (mobile) {
              if (scope.videoCreated && new Date(scope.videoCreated) > new Date('01/12/2017')) {
                link = link.split('.');
                var ext = link.splice(-2, 1);
                link[link.length - 2] += ext;
                link = link.join('.');
              }
              link = link.replace('.net/', '.net/hls/');
            }
            var temp = link.slice(0, -3);
            temp += ending;
            return temp;
          };

          // Verify if is a custom video and replace extension accordingly
          if (scope.videoSource === 'custom') {
            // Verify if mobile
            // if (Application.device.isMobile()) {
            //   //scope.videoLink = setLink(scope.videoLink, 'm3u8', true);
            //   var mobileLink = scope.videoLink.substr(0, scope.videoLink.lastIndexOf('.')) + '.m3u8';
            //   mobileLink = mobileLink.replace('cloudfront.net/', 'cloudfront.net/hls/').replace('.mp4.m3u8', 'mp4.m3u8');
            //   scope.videoLink = mobileLink;
            // } else
              if (Application.getBrowser().name !== 'Firefox'){
              //scope.videoLink = setLink(scope.videoLink, 'mp4');
              scope.videoLink = scope.videoLink.substr(0, scope.videoLink.lastIndexOf('.')) + '.mp4';
            } else if (Application.getBrowser().name === 'Firefox') {
              //scope.videoLink = setLink(scope.videoLink, 'webm');
              scope.videoLink = scope.videoLink.substr(0, scope.videoLink.lastIndexOf('.')) + '.webm';
            }
          }

          scope.newVideo = $sce.trustAsResourceUrl(scope.videoLink);
          elem.video.setAttribute('src', scope.newVideo);
          elem.video.load();

          var checkLoad = function () {
            if (elem.video.readyState >= 2) {
              scope.loading = false;
              if (seekTime) {
                seekTo(seekTime);
              }
              scope.$apply();
            } else {
              setTimeout(function () {
                checkLoad();
              }, 100);
            }
          };

          setTimeout(function () {
            checkLoad();
            elem.video.textTracks.addEventListener("change", syncFullScreen, false);
          }, 100);
        };

        scope.$on('$destroy', function() {
          record();
        });

        scope.$watch('videoLink', function (newVal, oldVal) {
          if (!newVal || newVal === oldVal) {
            return;
          }
          initialize();
        }, true);

        scope.trustVtt = function(url) {
          return $sce.trustAsResourceUrl(url);
        };

        scope.localeName = function(key) {
          for (var i = 0; i < locales.length; i ++) {
            if (locales[i].value === key) {
              return locales[i].name;
            }
          }
          return '--';
        };

        scope.hideAllCaptions = function() {
          scope.activeCaption = null;
          for (var i = 0; i < scope.fullElement.video.textTracks.length; i++) {
            scope.fullElement.video.textTracks[i].mode = 'hidden';
          };
          scope.displayCCMenu = false;
        };

        scope.showCaption = function(locale) {
          scope.activeCaption = locale;
          for (var i = 0; i < scope.fullElement.video.textTracks.length; i++) {
            scope.fullElement.video.textTracks[i].mode = scope.fullElement.video.textTracks[i].language === locale ? 'showing' : 'hidden';
          };
          scope.displayCCMenu = false;
        };

        scope.ccClick = function(e) {
          e.stopPropagation();
          if (!scope.vttFiles || !scope.vttFiles.length) {
            scope.activeCaption = null;
            return;
          }

          if (scope.vttFiles.length === 1) {
            if (!scope.activeCaption) {
              scope.showCaption(scope.vttFiles[0].locale);
              return;            
            }
            scope.hideAllCaptions();
            return;
          }

          scope.displayCCMenu = !scope.displayCCMenu;
        };

        var syncFullScreen = function() {
          var showingFound = false;
          for (var i = 0; i < scope.fullElement.video.textTracks.length; i++) {
            if (scope.fullElement.video.textTracks[i].mode === 'showing') {
              showingFound = true;
              if (scope.activeCaption !== scope.fullElement.video.textTracks[i].language) {
                scope.activeCaption = scope.fullElement.video.textTracks[i].language;
              }
            }
          }

          if (!showingFound && scope.activeCaption) {
            scope.activeCaption = null;
            scope.$apply();
          }
        };

        scope.playbackRates = [
          0.25,
          0.5,
          0.75,
          1,
          1.25,
          1.5,
          1.75,
          2
        ];

        scope.selectPlaybackRate = function(rate) {
          scope.fullElement.video.playbackRate = rate;
        }

        if (scope.videoLink) {
          initialize();
        }
      }
    };

  }]);
